import PropTypes from "prop-types";
import React, { Component } from "react";

import { OptionShape } from "../../policies/proptypes";
import SearchBox from "../../shared/components/SearchBox";

class LogsFilter extends Component {
  state = { open: false, value: "" };

  handleChange = e => {
    const filter = e.target.value;
    this.setState({ value: filter });
  };

  handleOptionClick = key => {
    const { filter, type, setFilter } = this.props;
    setFilter(type, filter === key ? "" : key);
    this.setState({ open: false, value: "" });
  };

  toggleOpen = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  resetFilter = () => {
    const { type, setFilter } = this.props;
    setFilter(type, "");
    this.setState({ value: "" });
  };

  getFilteredOptions = () => {
    const { value } = this.state;
    const { options } = this.props;

    return options.filter(option =>
      option.label.toLowerCase().includes(value.toLowerCase())
    );
  };

  generateOptions = () => {
    const { filter } = this.props;
    const options = this.getFilteredOptions();

    return options.map(option => (
      <li key={option.key} className="p-list__item">
        <button
          className={`p-button--list ${
            filter === option.key ? "is-selected" : ""
          }`}
          type="button"
          onClick={() => this.handleOptionClick(option.key)}
        >
          {option.label}
        </button>
      </li>
    ));
  };

  render() {
    const { open, value } = this.state;
    const { children, filter, position, showFilter } = this.props;

    return (
      <div className="p-filter">
        <button
          type="button"
          className={`p-filter__button ${filter ? "p-button--selected" : ""}`}
          onClick={() => this.toggleOpen()}
        >
          <span>{children}</span>
          <i className={`p-icon--chevron ${open ? "u-mirror--y" : ""}`} />
        </button>
        {open && (
          <div className="p-filter__dropdown" style={{ [position]: 0 }}>
            {showFilter && (
              <SearchBox
                style={{ marginBottom: "0" }}
                value={value}
                placeholder="Filter list"
                onChange={e => this.handleChange(e)}
                onReset={() => this.resetFilter()}
              />
            )}
            <ul className="p-list u-no-margin--bottom">
              {this.generateOptions()}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

LogsFilter.propTypes = {
  children: PropTypes.node,
  filter: PropTypes.string,
  options: PropTypes.arrayOf(OptionShape).isRequired,
  position: PropTypes.oneOf(["left", "right"]),
  setFilter: PropTypes.func.isRequired,
  showFilter: PropTypes.bool,
  type: PropTypes.oneOf(["author", "service", "date", "domain"]).isRequired
};

LogsFilter.defaultProps = {
  children: undefined,
  filter: "",
  position: "right",
  showFilter: true
};

export default LogsFilter;
